import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  container: {
    marginTop: 30,
    padding: '10px 0',
  },
}));
